import ScrollTransition from './transitions/scroll-transition';
import FadeTransition from './transitions/fade-transition';
export default {
  fade: FadeTransition,
  scroll: ScrollTransition
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nuka-carousel/es/all-transitions.js
// module id = 865
// module chunks = 0